import React from "react";
import Break from "../../../../../../components/Break";
import Collapsible from "../../../../../../components/Collapsible";
import Link from "../../../../components/Link";
import PageFooter from "../../../../components/PageFooter/index.js";
import * as ROUTES from "../../../../constants/routes.js";
import PopupPageDecoration from "../../../../views/HomeView/PopupPages/PopupPageDecoration";
import "./style.scss";

const ALL_JOBS_TITLE = "Get in touch";
function bucketAndSortJobs(jobs) {
  // renames
  jobs = jobs.map((job) => {
    if (job.location.name === "All Locations") {
      job.location.name = ALL_JOBS_TITLE;
      job.title =
        "Don’t see what you’re looking for? We’d still love to hear from you.";
    }
    // "Los Angeles" and "Los Angeles, CA" become a single set labeled for "Los Angeles":
    const split = job.location.name.split(",");
    if (split.length > 1) {
      job.location.name = split[0];
    }
    return job;
  });
  // Group jobs by location.name
  const buckets = jobs.reduce((acc, job) => {
    const locationName = job.location.name;
    if (!acc[locationName]) {
      acc[locationName] = [];
    }
    acc[locationName].push(job);
    return acc;
  }, {});

  // Convert the object into an array of { label, jobs }
  let result = Object.keys(buckets).map((locationName) => ({
    label: locationName,
    jobs: buckets[locationName].sort((a, b) => a.title.localeCompare(b.title)), // Sort jobs by job.title
  }));

  // Sort the result array by label (location.name)
  result.sort((a, b) => a.label.localeCompare(b.label));

  // Handle 'General Application' case - move it to the end if it exists
  const generalApplicationIndex = result.findIndex(
    (item) => item.label === ALL_JOBS_TITLE,
  );
  if (generalApplicationIndex > -1) {
    const generalApplication = result.splice(generalApplicationIndex, 1)[0]; // Remove it from the array
    result.push(generalApplication); // Add it to the end
  }

  return result;
}

class CareersHomePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      contentReady: false,
      jobs: [],
    };

    this.vars = {};
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    if (this.props.currentRoute !== prevProps.currentRoute) {
      Z.loadPage();
    }
  }

  init = async () => {
    const Z = this;

    Z.loadPage();
  };

  loadPage = async () => {
    const url = "https://boards-api.greenhouse.io/v1/boards/mediaartslab/jobs";
    const response = await fetch(url);
    const json = await response.json();
    const jobs = bucketAndSortJobs(json.jobs);
    this.setState({ jobs: jobs });

    if (this.props.setReady != null) {
      this.props.setReady(this.props.componentRoute, true);
    }
  };

  render() {
    const { jobs: jobLocations = [] } = this.state;
    return (
      <PopupPageDecoration isVertical={true}>
        <Break />

        <section
          style={{
            display: "flex",
            flexDirection: "column",
            paddingBottom: "4vw",
          }}
        >
          <h1>Work With us</h1>
          <div className="wwut">
            Creativity unites us together. Media Arts Lab is a unique space
            where you are heard, where you are supported and where you belong.
            We are a partnership of equals. Bring your fully authentic and
            slightly crazy selves and together we’ll create the best work we’ve
            ever done.
          </div>
        </section>

        <section style={{ width: "100%", paddingBottom: "20vw" }}>
          {jobLocations.map(({ label, jobs = [] }, index) => {
            return (
              <Collapsible key={`${label}-${index}`} header={label}>
                <div style={{ padding: "7.2751322751322745vw 0" }}>
                  {jobs.map((job) => (
                    <div key={job.id} className="job-content">
                      <div className="job">{job.title}</div>
                      <Link
                        to={ROUTES.CAREERS_ROLE.replace(
                          "/:roleId",
                          `/${job.id}`,
                        )}
                      >
                        View Role
                      </Link>
                    </div>
                  ))}
                </div>
              </Collapsible>
            );
          })}
        </section>

        <PageFooter />
      </PopupPageDecoration>
    );
  }
}

export default CareersHomePage;
